import React from "react";
import {VirtualizedTable} from "../../elements/VirtualizedTable";

const IdeasTable = (props) => {
    const {ideas} = props;

    const rowClassNameFunction = ({index}) => {
        return index === -1 ? "" : "t-idea-row";
    };

    return <VirtualizedTable headerHeight={32}
                             rowHeight={44}
                             bordered={true}
                             rowCount={ideas.length}
                             rowGetter={({index}) => ideas[index]}
                             rowClassName={rowClassNameFunction}
                             {...props}/>;
};

export default IdeasTable;